import React, {useEffect} from 'react'
import {Link} from "react-router-dom"

const Privacy = (props) => {

  useEffect(() => {
    window.scrollTo(0,0)
  },[])

  return ( <>
  <div style={{ position: 'relative' }}>

    <h3>Original</h3>
    <audio controls src={`${process.env.PUBLIC_URL}/songs/Back for the Wedding - OurStorySong.mp3`}></audio>
    <br/>
    <a href={`${process.env.PUBLIC_URL}/songs/Back for the Wedding - OurStorySong.mp3`} download>Download</a>

    <h3>Hair Metal</h3>
    <audio controls src={`${process.env.PUBLIC_URL}/songs/Back for the Wedding (Hair Metal) - OurStorySong.mp3`}></audio>
    <br/>
    <a href={`${process.env.PUBLIC_URL}/songs/Back for the Wedding (Hair Metal) - OurStorySong.mp3`} download>Download</a>

    <h2>Back for the Wedding</h2>

    <p>
    [Verse 1]<br/>
    Caleb flew in from the island sun,<br/>
    To marry Julia — the next great run.<br/>
    Dylan’s place became the crew HQ,<br/>
    Beryl and Troy touched down (delayed, but true).<br/>
    John brought pastries, flaky and sweet,<br/>
    Croissant loaf magic, a Kroger treat.<br/>
    Sarah rolled up late with midnight charm,<br/>
    Amanda's flight? Canceled — standard alarm.<br/>
    <br/>
    [Chorus]<br/>
    But we’re back for the wedding, back with the crew,<br/>
    From Kansas, Florida, North Carolina too.<br/>
    Frisbee fields behind us, but the memories hold,<br/>
    We’re older, we’re scattered — but the bond’s still gold.<br/>
    <br/>
    [Verse 2]<br/>
    We tried disc golf in the summer heat,<br/>
    Skipped the back five for something to eat.<br/>
    Planned on gelato but time slipped by,<br/>
    So Spartan Gyros came to satisfy.<br/>
    Amanda got FOMO mid-kid-wranglin’ haze,<br/>
    Booked a last-minute flight, set her gaze.<br/>
    She’s bunking at Caleb’s folks' cat-free zone,<br/>
    Still made the night feel just like home.<br/>
    <br/>
    [Chorus]<br/>
    Yeah, we’re back for the wedding, old jokes, new days,<br/>
    Mega-Bananagrams and nostalgic plays.<br/>
    From Frisbee flicks to late-night cheer,<br/>
    It’s like we never left — just once a year.<br/>
    <br/>
    [Verse 3]<br/>
    Wits and Wagers, pens dried out,<br/>
    But the guesses still made us laugh and shout.<br/>
    When asked about the Monuments reach,<br/>
    Amanda's guess, FIVE THOUSAND FEET!<br/>
    So far off, but we all agreed,<br/>
    That kind of guess is what the weekend needs.<br/>
    Years have flown, but the spark remains,<br/>
    In shared old jokes and foamer trains.<br/>
    <br/>
    [Bridge]<br/>
    From Winter Garden under twilight skies,<br/>
    To game nights lit with reunion highs.<br/>
    We don’t see each other most of the year,<br/>
    But give us a reason — and we all appear.<br/>
    <br/>
    [Final Chorus]<br/>
    So we’re back for the wedding, hearts in the right place,<br/>
    With laughter, gyros, and Amanda’s grace.<br/>
    One weekend of magic, before we depart —<br/>
    But every goodbye’s a Frisbee to the heart.<br/>
    </p>

    <img
    src={`${process.env.PUBLIC_URL}/songs/Caleb Wedding.jpeg`}
    alt="Caleb's Wedding"
    style={{
        // position: 'fixed',
        // top: '50%',
        // left: '75%',
        // transform: 'translate(-50%, -50%)',
        // opacity: 1,
        // zIndex: -99,
        // pointerEvents: 'none',
      width: '100%',
    }}
  />
    </div>
  </> )
}

export default Privacy
